
if (!customElements.get('honor-list-v3')) {
  class WhyChoose extends HTMLElement {
    constructor() {
      super();
      // const isMobile = `(max-width: 768px)`;
      // const isMobileMQL = window.matchMedia(isMobile);

      // isMobileMQL.addEventListener('change', (event) => {
      //   if (this.mySwiper) this.destroySwiper();
      //   if (event.matches) {
      this.createMobileSlider();
      //   }
      // });
      // if (isMobileMQL.matches) this.createMobileSlider();
    }

    createMobileSlider() {
      this.mySwiper = new Swiper(`#${this.id} .swiper-container`, {
        slidesPerView: 'auto',
        // loop: true,
        // freeMode: false,
        // speed: 30000,
        // grabCursor: true,
        // updateOnWindowResize: true,
        observer: true,
        resizeObserver: true,
        // pagination: {
        //   el: `#${this.id} .swiper-pagination`,
        //   clickable: true,
        // },
        // autoplay: {
        //   delay: 0,
        //   disableOnInteraction: false,
        // },
        // breakpoints: {
        //   590: {
        //     slidesPerView: 2,
        //   },
        // },
      });
    }

    destroySwiper() {
      this.mySwiper.destroy();
    }

    connectedCallback() { }
  }

  customElements.define('honor-list-v3', WhyChoose);
}